import { render, staticRenderFns } from "./IconSectionImage.vue?vue&type=template&id=763a2288&"
import script from "./IconSectionImage.vue?vue&type=script&lang=js&"
export * from "./IconSectionImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('763a2288')) {
      api.createRecord('763a2288', component.options)
    } else {
      api.reload('763a2288', component.options)
    }
    module.hot.accept("./IconSectionImage.vue?vue&type=template&id=763a2288&", function () {
      api.rerender('763a2288', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconSectionImage.vue"
export default component.exports